

export const NotFound = () =>  {
    return "Not found"
}